module.exports = __webpack_public_path__ + "img/retriggerassessment.3c54ba55.svg";